// Dynamic API URL utility - respects environment configuration
export const getApiBaseUrl = () => {
  // First priority: Use environment variable if set
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  // Fallback: Use tunnel domain for development
  return 'https://dev.gulfcoasthackers.com/api';
};

export const API_BASE_URL = getApiBaseUrl();

// Images CDN URL (Cloudflare R2)
export const getImagesBaseUrl = () => {
  if (process.env.REACT_APP_IMAGES_BASE_URL) {
    return process.env.REACT_APP_IMAGES_BASE_URL;
  }
  // Default to production images CDN
  return 'https://images.gulfcoasthackers.com';
};

export const IMAGES_BASE_URL = getImagesBaseUrl();

// Helper to construct proper image URLs
// Handles various path formats stored in the database
export const getImageUrl = (imagePath) => {
  if (!imagePath) return `${IMAGES_BASE_URL}/players/placeholder.png`;

  // If it's already a full URL, use it directly
  if (imagePath.startsWith('http')) return imagePath;

  // Normalize the path - strip legacy /uploads prefix if present
  let normalizedPath = imagePath;

  // Remove /uploads prefix if present (legacy paths)
  if (normalizedPath.startsWith('/uploads/')) {
    normalizedPath = normalizedPath.replace('/uploads/', '/');
  }

  // Ensure path starts with /
  if (!normalizedPath.startsWith('/')) {
    normalizedPath = `/${normalizedPath}`;
  }

  return `${IMAGES_BASE_URL}${normalizedPath}`;
};
